import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_BUILDING_BOILER',
  CREATE: 'ADD_BUILDING_BOILER',
  EDIT: 'EDIT_BUILDING_BOILER',
  DELETE: 'DELETE_BUILDING_BOILER',
  CLEAR_ERROR: 'CLEAR_ERROR_PROJECT',
};

export const listBoilerInBuilding = (pageSize, page, sorted, filtered, isPublic, buildingId) => {
  return {
    type: ACTION.LIST,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_PROJECT_BOILER,
      params: {
        search: filtered,
        limit: pageSize,
        offset: pageSize * page,
        ordering: sorted
          ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
          : null,
        is_public: isPublic,
        building_id: buildingId,
      }
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addBoilerToBuilding = (boilerId, buildingId, quantity) => {
  const data = {
    boiler_id: boilerId,
    building_id: buildingId,
    quantity: quantity,
  };

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_PROJECT_BOILER,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const editBoilerInBuilding = (buildingBoilerId, quantity) => {
  const data = {
    quantity,
  };

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_PROJECT_BOILER}${buildingBoilerId}/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeBoilerFromBuilding = (buildingBoilerId, buildingId) => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_PROJECT_BOILER}${buildingBoilerId}/`,
    })
      .then(() => ({ id: buildingBoilerId, building_id: buildingId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};


// WEBPACK FOOTER //
// ./src/redux/projects/project_boiler_actions.js